/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./linkBoard.vue?vue&type=template&id=ef33c202&scoped=true"
import script from "./linkBoard.vue?vue&type=script&lang=js"
export * from "./linkBoard.vue?vue&type=script&lang=js"
import style0 from "./linkBoard.vue?vue&type=style&index=0&id=ef33c202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef33c202",
  null
  
)

export default component.exports